import React from 'react';
import { Confirm, useDelete, useNotify, useRefresh } from 'react-admin';

export const DiameterDeleteDialog = ({
  // @ts-ignore
  showDeleteDialog,
  // @ts-ignore
  setShowDeleteDialog,
  // @ts-ignore
  id
}) => {
  const [erase] = useDelete();
  const notify = useNotify();
  const refresh = useRefresh();
  const onCloseDeleteDialog = () => {
    setShowDeleteDialog(false);
  };

  const onDelete = () => {
    erase(
      'diameters',
      {
        id
      },
      {
        onSuccess: () => {
          notify('resources.diameters.notifications.delete.success', {
            type: 'success'
          });
          onCloseDeleteDialog();
          refresh();
        },
        onError(error: any) {
          notify(error.message, { type: 'warning' });
        }
      }
    );
  };

  return (
    <Confirm
      title="resources.diameters.delete.title"
      content="resources.diameters.delete.message"
      onConfirm={onDelete}
      isOpen={showDeleteDialog}
      onClose={onCloseDeleteDialog}
    />
  );
};
